// For use in <time> tags containing a datetime attr
import moment from "moment"

// Get locale from server-provided I18n config
function getLocale() {
  return window.I18n?.numberFormat?.locale || "en"
}

export const relativeCalendarTime = {
  mounted() {
    convert(this.el)
  },
  updated() {
    convert(this.el)
  },
}

function convert(el) {
  const datetimeString = el.getAttribute("datetime")
  if (datetimeString) {
    const date = moment(datetimeString)
    date.locale(getLocale())
    el.innerText = date.calendar()
  }
}
